import React from "react";
import { Container } from "react-bootstrap";

const Page404 = () => (
  <Container className="d-flex align-items-center justify-content-center page404">
    <div className="text-center content-404">
      <img className="w-100" src="images/404pic.webp" alt="error-png" />
      <h1>صفحه‌ای که دنبال آن هستید وجود ندارد!</h1>
      <p>
        لطفاً مسیر درست را وارد کنید یا به <a href="/">صفحه اصلی</a> بازگردید.
      </p>
    </div>
  </Container>
);

export default Page404;
